import { Link, useLocation } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  path?: string;
}

const Breadcrumb = () => {
  const location = useLocation();

  const getBreadcrumbs = (): BreadcrumbItem[] => {
    const pathnames = location.pathname.split('/').filter((x) => x);
    
    const breadcrumbs: BreadcrumbItem[] = [
      { label: 'ダッシュボード', path: '/' },
    ];

    const pathMap: Record<string, string> = {
      'upload-management': 'アップロード管理',
      'book-download': '書籍ダウンロード',
      'member-management': '会員管理',
      'mbs-conversion': 'MBS変換',
      'email-magazine': 'メールマガ用データDL',
      'donation-report': '献本レポート',
      admin: '管理',
      'magazine-catch': 'マガジンキャッチ管理',
      list: '一覧',
      new: '新規',
      history: '履歴',
      settings: '設定',
      search: '検索',
      download: 'ダウンロード',
      convert: '変換実行',
      create: '作成',
      registration: '登録',
    };

    pathnames.forEach((pathname, index) => {
      const path = `/${pathnames.slice(0, index + 1).join('/')}`;
      const label = pathMap[pathname] || pathname;
      
      if (index === pathnames.length - 1) {
        breadcrumbs.push({ label });
      } else {
        breadcrumbs.push({ label, path });
      }
    });

    return breadcrumbs;
  };

  const breadcrumbs = getBreadcrumbs();

  return (
    <nav className="mb-6">
      <ol className="flex items-center space-x-2 text-sm text-admin-textLight">
        {breadcrumbs.map((breadcrumb, index) => (
          <li key={index} className="flex items-center">
            {index > 0 && <span className="mx-2">/</span>}
            {breadcrumb.path ? (
              <Link
                to={breadcrumb.path}
                className="hover:text-admin-accent transition-colors"
              >
                {breadcrumb.label}
              </Link>
            ) : (
              <span className="text-admin-text font-medium">{breadcrumb.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumb;
